// extracted by mini-css-extract-plugin
module.exports = {"sp_circle":"spinner_sp_circle__CV3xd","spCircRot":"spinner_spCircRot__Pt4F1"};